export default __webpack_public_path__ + "static/media/Logo.550cda84.svg";